// lodash components
import capitalize from 'lodash/capitalize'
import indexOf from 'lodash/indexOf'
import join from 'lodash/join'
import map from 'lodash/map'
import split from 'lodash/split'
import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'

import { useStore } from 'vuex'

function territory() {
    return process.env.TERRITORY
}

function moneyIcon() {
    switch (territory()) {
        case 'pol':
            return 'fas fa-coins'

        case 'usa':
        case 'aus':
            return 'fas fa-dollar-sign'

        default:
            return 'fas fa-pound-sign'
    }
}

function titleCase(payload) {
    const exceptions = [
        'a',
        'abaft',
        'about',
        'above',
        'afore',
        'after',
        'along',
        'amid',
        'among',
        'an',
        'apud',
        'as',
        'aside',
        'at',
        'atop',
        'below',
        'but',
        'by',
        'circa',
        'down',
        'for',
        'from',
        'given',
        'in',
        'into',
        'lest',
        'like',
        'mid',
        'midst',
        'minus',
        'near',
        'next',
        'of',
        'off',
        'on',
        'onto',
        'out',
        'over',
        'pace',
        'past',
        'per',
        'plus',
        'pro',
        'qua',
        'round',
        'sans',
        'save',
        'since',
        'than',
        'thru',
        'till',
        'times',
        'to',
        'under',
        'until',
        'unto',
        'up',
        'upon',
        'via',
        'vice',
        'with',
        'worth',
        'the',
        'and',
        'nor',
        'or',
        'yet',
        'so',
    ]

    const titleParts = map(split(startCase(payload), ' '), word => {
        return indexOf(exceptions, toLower(word)) === -1 ? capitalize(word) : toLower(word)
    })

    return join(titleParts, ' ')
}

function taxIdLabel() {
    const store = useStore()

    if (store.getters.fieldValue('employmentStatus') <= 3) {
        return store.state.global.$t('form.fields.nipPracodawcy.label')
    }

    return store.state.global.$t('form.fields.nipNumer.label')
}

//add list of short codes by rules
function shortCodes(store) {
    const shortCodes = { rental_mortgage: 'mortgage' }
    const addressFields = store.getters.fieldValue('currentAddressResidenceType')

    if (territory() !== 'gbr' && addressFields > 1) {
        shortCodes.rental_mortgage = 'rental'
    } else if (territory() === 'gbr' && (addressFields === 1 || addressFields === 10)) {
        shortCodes.rental_mortgage = 'mortgage'
    } else if (territory() === 'gbr' && (addressFields != 1 || addressFields != 10)) {
        shortCodes.rental_mortgage = 'rental'
    }

    return shortCodes
}

export { titleCase, moneyIcon, taxIdLabel, shortCodes, territory }
